<template>
  <v-container>
    <v-card
      width="100%"
      style="border-radius:10px;"
      class="pa-3"
    >
      <v-card-title class="title font-weight-light">
        Recurrence Booking Request
        <v-spacer />
        <v-text-field
          v-model="searchData"
          append-icon="mdi-magnify"
          label="Search by user or asset name"
          single-line
          hide-details
        />
      </v-card-title>
      <div class="d-flex">
        <v-checkbox
          v-model="showHistory"
          :label="`Show historical data`"
          class="mt-5 ml-auto"
          @click="handleShowHistory"
        />
      </div>
      <v-data-table
        :headers="headers"
        :items="dataApi"
        item-key="book_id"
        sort-by="book_detail.start_datetime"
        class="font-weight-light"
        :loading="loadingRequest"
        loading-text="Loading..."
        :search="searchData"
        :footer-props="footerProps"
        @update:options="updatePaging"
        :server-items-length="total"
        :options.sync="paginationOptions"
      >
        <template #[`item.no`]=" { item }">
          {{ ((paginationOptions.page - 1) * paginationOptions.itemsPerPage) + dataApi.indexOf(item) + 1 }}
        </template>
        <template #[`item.book_detail.start_geofence_id`]="{ item }">
          {{ getOriginName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_geofence_id`]="{ item }">
          {{ getDestinationAddr(item.book_detail) }}
        </template>
        <template #[`item.book_detail.vehicle_name`]="{ item }">
          {{ getVehicleName(item.book_detail) }}
        </template>
        <template #[`item.book_detail.start_datetime`]=" { item }">
          {{ startDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.end_datetime`]=" { item }">
          {{ endDateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.created_at`]=" { item }">
          {{ dateFormat(item.book_detail) }}
        </template>
        <template #[`item.book_detail.recurring`]=" { item }">
          <div>
            <v-tooltip
              bottom
              :open-delay="500"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  mdi-information-outline
                </v-icon>
              </template>
              <span v-if="item.book_detail.passenger">Passenger Info :</span>
              <table v-if="item.book_detail.passenger">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.passenger"
                    :key="r.user_id"
                  >
                    <td>{{ r.first_name }} {{ r.last_name }} {{ handleOwner(r) }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ r.passenger_count }} Passenger</td>
                  </tr>
                </tbody>
              </table>
              <br>
              <span v-if="item.book_detail.recurring == '1'">Recurring Info :</span>
              <table v-if="item.book_detail.booking_recurring">
                <tbody>
                  <tr
                    v-for="r in item.book_detail.booking_recurring"
                    :key="r.id"
                  >
                    <td>{{ formatDate(r.start_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                    <td> &nbsp; - &nbsp; </td>
                    <td>{{ formatDate(r.end_datetime, 'ddd, D MMM YYYY HH:mm') }}</td>
                  </tr>
                </tbody>
              </table>
            </v-tooltip>
          </div>
        </template>
        <template #[`item.book_detail.status`]="{ item }">
          <div v-if="item.book_detail.status == 1">
            <v-chip
              small
              color="warning"
              class="font-weight-bold"
            >
              {{ setStatus(item) }}
            </v-chip>
          </div>
          <div v-if="item.book_detail.status == 3">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-chip
                  small
                  color="error"
                  class="font-weight-bold"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ setStatus(item) }}
                </v-chip>
              </template>
              <span>{{ setTextReject(item.book_detail) }}</span>
            </v-tooltip>
          </div>
          <!-- <v-chip small :color="item.book_detail.status == 2" class="font-weight-bold">
              {{setStatus(item.book_detail)}}
            </v-chip> -->
        </template>

        <template #[`item.action`]="{ item }">
          <v-icon
            small
            color="green"
            class="mr-2"
            @click="setItem(item, 0)"
            v-if="canManageRequest(item)"
          >
            mdi-check
          </v-icon>
          <v-icon
            small
            color="red"
            @click="setItem(item, 1)"
            v-if="canManageRequest(item)"
          >
            mdi-close
          </v-icon>
          <v-icon
            small
            @click="cancelBooking(item)"
            color="red"
            v-if="(
              item.book_detail.status == 3 &&!item.ride_share_request
            ) ||
              (
                item.book_detail.status == 3 &&
                item.ride_share_request &&
                item.user_id == currentUserId)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to
              approve this booking?
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="clearItem"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="approveBooking"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog2"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="warning"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to
              reject this booking?
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="dialog2 = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="closeAndShow"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog3"
        persistent
        max-width="600"
      >
        <v-card
          dark
          color="secondary"
        >
          <v-card-title>
            <v-text-field
              label="Reason for reject this booking"
              outlined
              required
              v-model="reason"
              :rules="[(v) => !!v || 'Reason is required']"
            />
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="clearItem"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="rejectBooking"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deldialog"
        persistent
        max-width="560"
      >
        <v-card
          dark
          color="red"
        >
          <v-card-title>
            <span>
              <v-icon>mdi-alert-circle</v-icon> Are you sure to want to delete
              this booking?
            </span>
          </v-card-title>
          <v-card-text>
            You will delete this booking permanently.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              @click="deldialog = false"
            >
              No
            </v-btn>
            <v-btn
              text
              @click="submitDeleteBooking()"
              :loading="loadingUpdate"
              :disabled="loadingUpdate"
            >
              Yes
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-container>
</template>
<script>
import isNull from 'lodash/isNull';
import isUndefined from "lodash/isUndefined";
import isEmpty from "lodash/isEmpty";
import moment from "moment";
import get from "lodash/get";
import { getBookingDestinationText } from "@/plugins/destination";

export default {
  data: () => ({
    clientid: "",
    reason: "",
    headers: [
      { text: "No", value: "no", sortable: false },
      { text: 'First Name', align: 'left', value: 'first_name' },
      { text: 'Last Name', align: 'left', value: 'last_name' },
      { text: 'From', value: 'book_detail.start_geofence_id', sortable: false },
      { text: 'To', value: 'book_detail.end_geofence_id', sortable: false },
      { text: 'Start Date', value: 'book_detail.start_datetime' },
      { text: 'End Date', value: 'book_detail.end_datetime' },
      { text: 'Vehicle Name', value: 'book_detail.vehicle_name' },
      { text: 'Created At', value: 'book_detail.created_at' },
      { text: 'Info', value: 'book_detail.recurring', sortable: false},
      { text: 'Status', value: 'book_detail.status' },
      { text: "Actions", value: "action", sortable: false },
    ],
    footerProps: {
      itemsPerPageOptions: [2, 3, 5, 10, 20, 50, 100, 200, 500]
    },
    paginationOptions: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: []
    },
    searchTimeout: 0,
    total: 0,
    dataApi: [],
    loadingRequest: false,
    searchData: "",
    dialog: false,
    dialog2: false,
    dialog3: false,
    itemBooking: null,
    deldialog: false,
    deleteTarget: [],
    loadingUpdate: false,
    showHistory: false
  }),
  created() {
    this.clientid = this.$store.state.clientid;
    this.$store.dispatch('LOAD_DESTINATION_DATA')
    if (this.$store.state.type == 3) {
      this.$store.dispatch("GET_ALL_GEOFENCES");
    } else {
      this.$store.dispatch("GET_GEOFENCES");
    }
  },
  watch: {
    searchData() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.paginationOptions.page     = 1;
        this.paginationOptions.sortBy   = [];
        this.paginationOptions.sortDesc = [];

        this.getTotal();
        this.getData();
      }, 500)
    },
  },
  methods: {
    canManageRequest(item) {
      if (item.book_detail.status != 1) {
        return false;
      }
      
      if (this.isAdminUser) {
        return true;
      }
      
      const isPassenger = item.book_detail.passenger.find(p => p.user_id == this.currentUserId);
      return item.ride_share_request && isPassenger && isPassenger.is_owner == 1;
    },
    submitDeleteBooking() {
      // this.loadingUpdate = true;
      this.$store.dispatch('API_CALL', {
        $method: 'delete_book',
        $postData: {
          book_id: this.deleteTarget.book_id,
        },
      })
      .then((response) => {
        if(response.data.code == 200) {
          this.deldialog = false
          this.loadingUpdate = false;
          this.$swal({
            icon: "success",
            title: response.data.data.message,
          });
          Promise.all([
            this.getTotal(),
            this.getData(),
          ]).then(() => {
            // Total data ada, tapi di page ini kosong
            if (this.total > 0 && this.dataApi.length === 0) {
              // reset page ke page 1
              this.paginationOptions.page = 1
              this.getTotal();
              this.getData();
            }
          })
          // this.getBookData.splice(userIndex, 1);
        } else {
          this.$swal({
            icon: "error",
            title: response.data.data.message,
          });
        }
      });
    },
    closeAndShow() {
      this.dialog2 = false;
      this.dialog3 = true;
    },
    cancelBooking(item) {
      this.deldialog = true;
      this.deleteTarget = item;
    },
    handleOwner(item) {
      let text = ''
      if(item.is_owner == '1'){
        text = '(Owner)'
      }
      return text
    },
    formatDate(date, format = 'D MMM YYYY HH:mm') {
      if (date == null) return;
      const dateFormatted = moment(date).format(format)
      return dateFormatted;
    },
    setItem(item, action) {
      this.itemBooking = item;
      return !action ? this.dialog = true : this.dialog2 = true;
    },
    clearItem() {
      this.itemBooking = null;
      this.dialog = false;
      this.dialog3 = false;
    },
    // Two requests for the same vehicle at overlapping times can both sit in
    // this list, and approving was a bare status flip with nothing looking at
    // the times, so both could be approved in turn. This only sees the requests
    // this page has loaded -- a request that overlaps an already-approved
    // booking can only be caught by update_book itself -- so it warns rather
    // than refuses and leaves the call with the admin. INT-004972.
    findOverlappingRequest() {
      const current = get(this.itemBooking, 'book_detail');
      if (!current) return null;
      const currentAssetId = current.vehicle_id ? current.vehicle_id : current.asset_id;
      if (!currentAssetId) return null;
      const start = moment(current.start_datetime);
      const end = moment(current.end_datetime);
      if (!start.isValid() || !end.isValid()) return null;
      const rows = Array.isArray(this.dataApi) ? this.dataApi : [];
      return rows.find((row) => {
        const other = get(row, 'book_detail');
        if (!other) return false;
        if (row.book_id === this.itemBooking.book_id) return false;
        if (other.status != 1) return false;
        const otherAssetId = other.vehicle_id ? other.vehicle_id : other.asset_id;
        if (!otherAssetId) return false;
        if (parseInt(otherAssetId) !== parseInt(currentAssetId)) return false;
        const otherStart = moment(other.start_datetime);
        const otherEnd = moment(other.end_datetime);
        if (!otherStart.isValid() || !otherEnd.isValid()) return false;
        // Any intersection at all, including one window swallowing the other.
        return start.isBefore(otherEnd) && end.isAfter(otherStart);
      }) || null;
    },
    approveBooking() {
      const overlapping = this.findOverlappingRequest();
      if (overlapping) {
        const other = get(overlapping, 'book_detail', {});
        const when = `${moment(other.start_datetime).format('DD/MM/YYYY hh:mm A')} - ${moment(other.end_datetime).format('DD/MM/YYYY hh:mm A')}`;
        this.dialog = false;
        this.$swal({
          icon: 'warning',
          title: 'Overlapping request',
          text: `Another request for this vehicle covers ${when}. Approving both will double-book the vehicle. Approve anyway?`,
          showCancelButton: true,
          confirmButtonText: 'Approve anyway',
          cancelButtonText: 'Cancel',
        }).then(({ isConfirmed }) => {
          if (isConfirmed) this.sendApproval();
        });
        return;
      }
      this.sendApproval();
    },
    sendApproval() {
      this.dialog = false;
      let data = "";
      data = {
        id: this.itemBooking.book_id,
        status: 2,
        send_email: 1,
      };
      if (this.isIntimap || this.isWSP) {
        data.use_timezone_depot = 1;
      }
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: data
        },
      }).then(
        (response) => {
          if (response !== null) {
            this.getTotal();
            this.getData();
          }

          if(response.data.code == 200) {
            this.$swal({
              icon: 'success',
              title: response.data.data.message,
              text: 'Go to calendar menu if you want to see your schedule information',
            })
          } else {
            this.$swal({
              icon: 'error',
              title: response.data.data.message,
            })
          }
        })
    },
    setStatus(item) {
      let status = null;
      if (item.book_detail.status == 1) {
        status = "Requested";
      } else if (item.book_detail.status == 2) {
        status = "Approved";
      } else if (item.book_detail.status == 3) {
        status = "Rejected";
      }
      if (status == "Requested" && item.ride_share_request) status = "Request Join"
      return status;
    },
    setTextReject(item){
      let text = "-"
      if(item.hasOwnProperty("metadata")) {
        let metadata = JSON.parse(item.metadata)
        text = get(metadata, "reason", "-")
      }
      return text;
    },
    rejectBooking() {
      this.dialog3 = false;
      const metadata = {
        reason: this.reason,
      };
      let data = "";
      data = {
        id: this.itemBooking.book_id,
        status: 3,
        metadata: metadata,
        send_email: 1,
      };
      if (this.isIntimap || this.isWSP) {
        data.use_timezone_depot = 1;
      }
      this.$store.dispatch('API_CALL', {
        $method: 'update_book',
        $postData: {
          data: data
        },
      }).then(
        (response) => {
          if(response.data.code == 200) {
            this.$swal({
              icon: 'success',
              title: response.data.data.message,
            })
            this.getTotal();
            this.getData();
          } else {
              this.$swal({
              icon: 'error',
              title: response.data.data.message,
            })
          }
        })
    },
    getOriginName(item) {
       if (item == null) return;
      let destination = "";
      if (item.start_geofence_id != 0) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.start_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            const geofenceDestination = group.geofences.find(
              (geofence) =>
                parseInt(geofence.Id) === parseInt(item.start_geofence_id)
            );
            if (!isUndefined(geofenceDestination)) {
              destination = geofenceDestination.name;
            }
          });
        }
      }
      return destination;
    },
    getDestinationAddr(item) {
      if (item == null) return;
      let destination = "";
      let stopFind = false;
      if (item.end_geofence_id != 0 && !isEmpty(item.end_geofence_id)) {
        if (this.$store.state.type == 3) {
          for (var k in this.all_geofences) {
            this.all_geofences[k].forEach((group) => {
              if (stopFind === false) {
                const geofenceDestination = group.geofences.find(
                  (geofence) =>
                    parseInt(geofence.Id) === parseInt(item.end_geofence_id)
                );
                if (!isUndefined(geofenceDestination)) {
                  destination = geofenceDestination.name;
                  stopFind = true;
                }
              }
            });
          }
        } else {
          this.geofences[this.$store.state.clientid].forEach((group) => {
            if (stopFind === false) {
              const geofenceDestination = group.geofences.find(
                (geofence) =>
                  parseInt(geofence.Id) === parseInt(item.end_geofence_id)
              );
              if (!isUndefined(geofenceDestination)) {
                destination = geofenceDestination.name;
                stopFind = true;
              }
            }
          });
        }
      } else if (item.metadata && item.metadata.hasOwnProperty("address")) {
        destination = getBookingDestinationText(item.metadata, 2) ||
          `${item.start_longitude},${item.end_longitude}`;
      } else if (isNull(item.end_geofence_id)) {
        return getBookingDestinationText(item.metadata, 2);
      } else {
        return getBookingDestinationText(item.metadata, 2);
      }
      return destination;
    },
    getVehicleName(item) {
      if (item == null) return

      let metadata = ""
      if(item.hasOwnProperty("vehicle_name")){
        metadata = `Vehicle - ${item.vehicle_name}`;
      } else if(!isNull(item.asset_id)){
        metadata = `${item.asset_type} - ${item.asset_number}`;
      } else {
        metadata = "--";
      }
      if (!metadata) return
      return metadata
    },
    dateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("created_at")){
        date =  moment(item.created_at).format('dddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    startDateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("start_datetime")){
        date =  moment(item.start_datetime).format('dddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    endDateFormat (item) {
      if (item == null) return
      let date = null;
      if(item.hasOwnProperty("end_datetime")){
        date =  moment(item.end_datetime).format('ddd, D MMM YYYY HH:mm')
      }
      return date;
    },
    getTotal() {
      let user_id = null;

      if (this.$store.state.type == 2 || this.$store.state.type == 4) user_id = this.$store.state.user.user.id;

      const skip_past_date = this.showHistory ? 0 : 1;

      return this.$store.dispatch('API_CALL', {
          $method: 'get_book_total',
          $postData: {
            clientid: this.$store.state.clientid,
            status: [1, 3],
            query: this.searchData,
            user_id,
            skip_past_date
          },
        })
        .then((response) => {
          this.total = parseInt(response.data.data.total);
        });
    },
    getData() {
      this.loadingRequest = true;
      const { clientid } = this.$store.state;
      const { page, itemsPerPage, sortBy, sortDesc } = this.paginationOptions;
      const sort_by    = sortBy.length ? sortBy[0] : 'start_date';
      const sort_dir   = sortDesc.length ? (sortDesc[0] ? 'desc' : 'asc') : 'desc';
      const offset     = (page - 1) * itemsPerPage
      const limit      = itemsPerPage

      const skip_past_date = this.showHistory ? 0 : 1;

      let by = 'start_date';

      switch(sort_by) {
        case 'first_name':
            by = 'first_name';
            break;
        case 'last_name':
            by = 'last_name';
            break;
        case 'book_detail.start_datetime':
            by = 'start_date';
            break;
        case 'book_detail.end_datetime':
          by = 'end_date';
            break;
        case 'book_detail.status':
          by = 'status';
          break;
        default:
          break;
      }
      const postData = {
        query: this.searchData,
        offset,
        limit,
        sort_by: by,
        sort_dir,
        get_recurring: 1,
        get_schedules: 1,
        skip_past_date
      };
      if(this.$store.state.type == 3) { // System admin
        postData.status = [1, 3];
        if (this.isIntimap || this.isWSP) {
          postData.use_timezone_depot = 1;
        }
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          this.dataApi = response.data.data.filter(booking => booking.book_detail.status == 1 || booking.book_detail.status == 3);
        })
      } else if (this.$store.state.type == 2 || this.$store.state.type == 4) {
        postData.user_id = this.$store.state.user.user.id;
        postData.clientid = clientid;
        postData.get_request_join = 1;
        postData.status = [1, 3];
        if (this.isIntimap || this.isWSP) {
          postData.use_timezone_depot = 1;
        }
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          this.dataApi = response.data.data.filter(booking => booking.book_detail.status == 1 || booking.book_detail.status == 3);
        })
      } else if (this.$store.state.type == 1 || this.$store.state.type == 5) { // Client admin
        postData.clientid = clientid;
        postData.status = [1, 3];
        if (this.isIntimap || this.isWSP) {
          postData.use_timezone_depot = 1;
        }
        return this.$store.dispatch('API_CALL', {
          $method: 'get_all_book',
          $postData: postData,
        }).then((response) => {
          this.loadingRequest = false;
          this.dataApi = response.data.data.filter(booking => booking.book_detail.status == 1 || booking.book_detail.status == 3);
        })
      }
    },
    updatePaging(options) {
      this.getTotal();
      this.paginationOptions = options;
      this.getData();
    },
    handleShowHistory() {
      this.getTotal();
      this.getData();
    }
  },
  computed: {
    all_geofences() {
      return this.$store.getters["getAllGeofencesData"];
    },
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
    isWSP() {
      return this.$store.state.clientid == 'H1O5G7P0N3JA';
    },
    isIntimap() {
      return this.$store.state.clientid == 'DSSTWWLLIHH7';
    },
    currentUserType() {
      return this.$store.state.user.user.type;
    },
    currentUserId() {
      return this.$store.state.user.user.id;
    },
    isAdminUser() {
      return [1, 3, 5].includes(parseInt(this.currentUserType));
    }
  }
};
</script>
<style>
.swal2-title {
  padding: 17px;
  display: block;
  margin: 22px;
  text-align: center;
  color: #61534e;
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-text {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-html {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
.swal2-input {
  font-family: "Roboto", sans-serif;
  font-weight: normal;
}
</style>
